/* eslint-disable jsx-a11y/control-has-associated-label */
import get from 'lodash/get';
import { arrayOf, func, object, objectOf, string } from 'prop-types';
import React from 'react';
import { Table } from 'reactstrap';

import { productShape } from '../../prop-types';

function DistributionTable({
  kpi,
  countries,
  products,
  countryTotals,
  productTotals,
  shares,
  displayComponent,
}) {
  return (
    <Table striped borderless>
      <thead>
        <tr>
          <th style={{ width: 250 }} />
          {countries.map(country => {
            const countryTotal = countryTotals[country];
            return (
              <th style={{ width: 250 }} key={country}>
                {country} {countryTotal && `(${countryTotal[kpi]})`}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {products.map(product => {
          const productTotal = productTotals[product.code];
          return (
            <tr key={product.code}>
              <td>
                {product.name} {productTotal && `(${productTotal[kpi]})`}
              </td>
              {countries.map(country => {
                const key = `${product.code}.${country}`;
                return (
                  <td key={key}>
                    {displayComponent(
                      get(shares, [product.code, country]),
                      product,
                      country,
                    )}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

DistributionTable.propTypes = {
  kpi: string,
  countries: arrayOf(string.isRequired).isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  countryTotals: objectOf(object.isRequired),
  productTotals: objectOf(object.isRequired),
  shares: objectOf(object.isRequired).isRequired,
  displayComponent: func.isRequired,
};

DistributionTable.defaultProps = {
  kpi: '',
  countryTotals: {},
  productTotals: {},
};
export default DistributionTable;
